<template>
  <b-card class="row-height" no-body>
    <div class="mb-1">
      <b-card no-body class="card-statistics" style="">
        <b-card-body class="statistics-body">
          <h2 class="text-purple font-weight-bold mb-1">
            <b-link class="btn btn-outline-primary" to="/">
              <FeatherIcon icon="ChevronLeftIcon"></FeatherIcon>
              {{ $t("back") }}
            </b-link>
            {{ $t("deposit_funds") }}
          </h2>
          <br /><br />
          {{ $t("deposit_subtitle") }} <br />
          <br />
          {{ $t("introductions") }}:
          <b-row>
            <b-col
              v-for="(item, index) in invoiceData"
              :key="index"
              md="3"
              sm="6"
              class="mb-2 mb-md-0 col-md-12 mt-3 mb-3"
            >
              <b-media no-body>
                <b-media-aside class="mr-2">
                  <b-avatar size="48" :variant="'light-' + item.variant">
                    <feather-icon size="24" :icon="item.icon" />
                  </b-avatar>
                </b-media-aside>
                <b-media-body class="my-auto row">
                  <h4 class="col-xl-2 col-lg-3 col-md-6 font-weight-bolder">
                    {{ $t(item.text) }}
                  </h4>

                  <h4
                    class="col-xl-3 col-lg-4 col-md-6 font-weight-bolder mb-0"
                    v-html="item.value"
                  ></h4>
                </b-media-body>
              </b-media>
            </b-col>
          </b-row>

          <br /><br /><br />
          <b-col class="alert alert-primary p-2 col-md-12">
            <div class="row ml-1">
              <feather-icon variant="primary" size="20" icon="InfoIcon" />
              <h5 class="text-primary ml-1">
                {{ $t("deposit_important_note") }}
              </h5>
            </div>
          </b-col>
        </b-card-body>
      </b-card>
      <br />
      <br /><br />
      <br />
      <br /><br />
      <b-col class="col-md-12" align="end">
        <b-button variant="primary" @click="setCookpitToCompleted">{{
          $t("i_will_do_it")
        }}</b-button>
      </b-col>
    </div>
  </b-card>
</template>
<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent";
export default {
  name: "TransferSymbolicAmount",
  data() {
    return {
      iban: "",
      bank_name: "",
      bank_address: "",
      betrag: "",
      beneficiary: {
        name: "",
        address: "",
        zip: "",
        city: "",
        state: "",
      },
      refference_num: "",
      bic: "",
      clearing: "",
      invoiceData: [],
    };
  },
  created() {
    this.refference_num =
      this.$store.state.app.company &&
      this.$store.state.app.company.value &&
      this.$store.state.app.company.value.id_code
        ? this.$store.state.app.company.value.id_code
        : "/";

    this.invoiceData = [
      {
        text: "betrag",
        value: "CHF 5.00",
        icon: "DollarSignIcon",
        variant: "success",
      },
      {
        text: "beneficiary",
        value:
          "Aequitex AG" +
          "<br />" +
          "Gubelstrasse 24" +
          "<br />" +
          "6300 Zug, Switzerland",
        icon: "MapPinIcon",
        variant: "success",
      },
      {
        text: "IBAN",
        value: "GB53IFXS23229069521518",
        icon: "CreditCardIcon",
        variant: "primary",
      },
      {
        text: "bank_name",
        value: "IFX Payments",
        icon: "HomeIcon",
        variant: "secondary",
      },
      {
        text: "bic",
        value: "IFXSGB2L",
        icon: "CreditCardIcon",
        variant: "info",
      },
      {
        text: "Clearing",
        value: "787",
        icon: "LockIcon",
        variant: "warning",
      },
      {
        text: "reference_number_payment_reason",
        value: this.refference_num,
        icon: "DollarSignIcon",
        variant: "success",
      },
    ];
    this.getDepositBankDetails();
    this.getIbanDetails();
  },
  methods: {
    getIbanDetails() {
      this.$http.post("/currency/get-iban").then((res) => {
        if (res.data.status === 200 && Array.isArray(res.data.value)) {
          const chf = res.data.value.find((item) => item.currency_id === 1);
          const iban = chf?.iban || "GB53IFXS23229069521518";
          this.invoiceData = this.invoiceData.map((item) => {
            if (item.text === "IBAN") {
              return { ...item, value: iban };
            }
            return item;
          });
        }
      });
    },
    getDepositBankDetails() {
      this.$http.post("/currency/deposit-bank-details").then((res) => {
        if (res.data.status === 200 && res.data.value) {
          const details = res.data.value;
          this.invoiceData = this.invoiceData.map((item) => {
            if (item.text === "bank_name") {
              return { ...item, value: details.bank_name || "IFX Payments" };
            }
            if (item.text === "bic") {
              return { ...item, value: details.bic || "IFXSGB2L" };
            }
            return item;
          });
        }
      });
    },
    changeStatus() {
      this.$http.post("/buyer/changeThirdTaskStatus").then((res) => {
        if (res) {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: this.$t(res.data.message),
              icon: "SuccessIcon",
              variant: "success",
            },
          });
          this.$router.push("/");
        }
      });
    },
    setCookpitToCompleted() {
      this.$http.post("/buyer/updateCookpitTransfer").then((res) => {
        this.$toast({
          component: ToastificationContent,
          props: {
            title: this.$t(res.data.message),
            icon: "SuccessIcon",
            variant: "success",
          },
        });
        this.$router.push("/");
      });
    },
  },
};
</script>
